import { toQueryParamArray, useQueryParam } from '~publish/hooks/useQueryParam'

import { useTagsQuery } from './useTags'
import type { UseTagsQueryReturn } from './useTags'

export function useSelectedTags(
  queryParamName = 'tags',
): UseTagsQueryReturn['tags'] {
  const [rawSelectedTagIds] = useQueryParam<string[]>(queryParamName)
  const selectedTagIds = toQueryParamArray(rawSelectedTagIds)
  const { tags } = useTagsQuery()

  return tags.filter((tag) => selectedTagIds.includes(tag.id))
}
